// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"344":"d5640c66","375":"2abbba29"}[chunkId] + ".chunk.css";
};